/** Settings-area permission keys from GET /permission/get/:role_id (permissions.key). */
export const SETTINGS_PERMISSION_KEYS = {
  USER_SETTINGS: "user_settings",
  PARTNER_PROGRAM_SETTINGS: "partner_program_settings",
  PARTNER_MANAGEMENT_SETTINGS: "partner_management_settings",
  VALIDATION_SETTINGS: "validation_settings",
  TECHNOLOGY_SETTINGS: "technology_settings",
} as const;

/** Any settings-area key grants access to the Settings shell route. */
export const SETTINGS_AREA_PERMISSION_KEYS = [
  SETTINGS_PERMISSION_KEYS.USER_SETTINGS,
  SETTINGS_PERMISSION_KEYS.PARTNER_PROGRAM_SETTINGS,
  SETTINGS_PERMISSION_KEYS.PARTNER_MANAGEMENT_SETTINGS,
  SETTINGS_PERMISSION_KEYS.VALIDATION_SETTINGS,
  SETTINGS_PERMISSION_KEYS.TECHNOLOGY_SETTINGS,
] as const;
